import * as React from "react";
import { graphql } from "react-apollo";
import { Link } from "react-router-dom";
import BODebounceInput from "app/components/BOComponents/BODebounceInput";

import { DeviceFraudStatusIcon } from "app/components/AppComponents/Fraud";

import DatePicker from "material-ui/DatePicker";
import SelectField from "material-ui/SelectField";
import MenuItem from "material-ui/MenuItem";
import Dialog from "material-ui/Dialog";
import * as moment from "moment-timezone";

import { topDevicesList } from "./Fraud.TopDevicesList.Query";

// JQUERY
import * as $ from "jquery";

// AUTH
import oktaClient from "app/utils/oktaClient";

const historyName = "ss_fraud_top_devices";

class TopDevices extends React.Component<any, any> {
  constructor(props: any) {
    super(props);

    // SETS DEAULT TO PREVIOUS DAY
    const filterDate = new Date();
    filterDate.setDate(filterDate.getDate() - 1);
    // TO USE SET filterDate: filterDate IN STATE

    this.state = {
      data: null,
      loading: false,
      merchantSearch: "",
      limit: 30,
      offset: 0,
      filterDate: this.props.savedStates[historyName]
        ? this.props.savedStates[historyName].filterDate
        : filterDate,
      selectedRows: [],
      shiftKey: false,
      lastItem: null,
      open: false,
      logData: "",
    };

    this.loadData = this.loadData.bind(this);

    //  PAGINATION
    this.loadNext = this.loadNext.bind(this);
    this.loadPrev = this.loadPrev.bind(this);

    this.handleGroupStatus = this.handleGroupStatus.bind(this);
    this.runUpdate = this.runUpdate.bind(this);
    this.toggleAll = this.toggleAll.bind(this);
    this.checkRows = this.checkRows.bind(this);
    this.selectRow = this.selectRow.bind(this);

    this.closeModal = this.closeModal.bind(this);
    this.openModal = this.openModal.bind(this);
  }

  componentDidMount() {
    const thiss = this;
    document
      .getElementById("setHeight")
      .addEventListener("scroll", function () {
        var translate = "translate(0," + this.scrollTop + "px)";
        this.querySelector("thead").style.transform = translate;
      });
    $(document).on("keyup keydown", function (e: any) {
      thiss.setState({ shiftKey: e.shiftKey });
    });
    this.loadData(
      this.props.savedStates[historyName]
        ? this.props.savedStates[historyName].merchantSearch
        : "",
      this.props.savedStates[historyName]
        ? this.props.savedStates[historyName].filterDate
        : this.state.filterDate,
      this.props.savedStates[historyName]
        ? this.props.savedStates[historyName].offset
        : this.state.offset
    );
    this.props.setHeader({
      title: "Fraud > Top Devices",
      description: "Top SnapScan devices",
    });
  }

  componentWillUnmount() {
    $(document).off("keyup keydown");
  }

  loadData(merchantSearch: String, getFilter: any, getOffset: any) {
    this.props.addToStates("ss_fraud_top_devices", {
      merchantSearch,
      filterDate: getFilter,
      offset: getOffset,
    });
    this.setState({
      loading: true,
      data: null,
      filterDate: getFilter,
      offset: getOffset,
      merchantSearch,
    });
    let createdAtFrom = null;
    let createdAtTo = null;

    if (getFilter !== null) {
      const setDateFrom = moment(getFilter)
        .startOf("day")
        .tz("Africa/Johannesburg")
        .format();
      const setDateTo = moment(getFilter)
        .endOf("day")
        .tz("Africa/Johannesburg")
        .format();
      createdAtFrom = setDateFrom;
      createdAtTo = setDateTo;
    }

    this.props.data.fetchMore({
      variables: {
        from: createdAtFrom,
        to: createdAtTo,
        offset: getOffset,
        merchant_search: merchantSearch,
      },
      updateQuery: (previousResult, { fetchMoreResult }) => {
        this.setState({ data: fetchMoreResult.fraud, loading: false });
      },
    });
  }

  loadNext() {
    const TMP_OFFSET =
      parseInt(this.state.offset, 10) + parseInt(this.state.limit, 10);
    this.loadData(this.state.merchantSearch, this.state.filterDate, TMP_OFFSET);
  }

  loadPrev() {
    const TMP_OFFSET =
      parseInt(this.state.offset, 10) - parseInt(this.state.limit, 10);
    this.loadData(this.state.merchantSearch, this.state.filterDate, TMP_OFFSET);
  }

  closeModal() {
    this.setState({ open: false, logData: "" });
  }

  openModal(data: any) {
    this.setState({ open: true, logData: data });
  }

  changeDate(event: any, date: any) {
    this.loadData(this.state.merchantSearch, date, 0);
  }

  handleGroupStatus(e: any, key: any, status: any) {
    var token = oktaClient.getToken();
    const comment = "Updated by " + token.claims.email;
    var data = [];
    this.state.data.top_devices_by_volume.map((item, i) => {
      return this.state.selectedRows.map((value, keyRow) => {
        if (parseInt(value, 10) === i) {
          var temp = [];
          temp["external_ref"] = item.devices[0].external_reference;
          temp["comment"] = comment;
          temp["status"] = status;

          data.push(temp);
        }
        return "1";
      });
    });
    this.runUpdate(data, this.state);
  }

  runUpdate(data: any, state: any) {
    const thiss = this;
    data.map((value, key) => {
      $.ajax({
        type: "POST",
        url:
          process.env["REACT_APP_" + process.env.REACT_APP_ENV + "_LINK"] +
          "/integration/console/fraud/device/fraud_status",
        data: {
          external_reference: value["external_ref"],
          comment: value["comment"],
          status: value["status"],
        },
        headers: {
          Authorization: oktaClient.getAuthorizationHeader(),
          "x-User-Groups": ["snapscan", "wechat", "masterpass"],
        },
      }).done(function () {
        thiss.loadData(state.merchantSearch, state.filterDate, state.offset);
        thiss.setState({ selectedRows: [] });
      });
      return "1";
    });
  }

  checkRows() {
    const tmpArr = [];
    $(".itemSelect").map(function (key: any, val: any) {
      if ($(val).is(":checked")) {
        tmpArr.push(val.value);
      }

      return "1";
    });
    this.setState({ selectedRows: tmpArr });
  }

  toggleAll(e: any) {
    if ($(e.target).is(":checked")) {
      $(".itemSelect").prop("checked", true);
    } else {
      $(".itemSelect").prop("checked", false);
    }
    this.checkRows();
  }

  selectRow(e: any) {
    const value = $(e.target).val();
    if (this.state.shiftKey) {
      if (this.state.selectedRows.length > 0) {
        const lastItem = this.state.lastItem;
        if (parseInt(value, 10) > parseInt(lastItem, 10)) {
          $(".itemSelect").map(function (key: any, val: any) {
            if (
              parseInt($(val).val(), 10) > parseInt(lastItem, 10) &&
              parseInt($(val).val(), 10) < parseInt(value, 10)
            ) {
              $(val).prop("checked", true);
            }

            return "1";
          });
        } else {
          $(".itemSelect").map(function (key: any, val: any) {
            if (
              parseInt($(val).val(), 10) < parseInt(lastItem, 10) &&
              parseInt($(val).val(), 10) > parseInt(value, 10)
            ) {
              $(val).prop("checked", true);
            }

            return "1";
          });
        }
      } else {
        this.setState({ lastItem: value });
      }
    } else {
      this.setState({ lastItem: value });
    }
    this.checkRows();
  }

  render() {
    const topDevicesList = this.state.data
      ? this.state.data.top_devices_by_volume
      : [];

    const devices = (allDevices) => {
      const count = Object.keys(allDevices).length;
      return (
        <div>
          {count} - <DeviceFraudStatusIcon device={allDevices[0]} />
        </div>
      );
    };

    const merchants = (topMerchants) => {
      return topMerchants.map((merchant, mi) => {
        return (
          <div key={mi}>
            <Link
              className="blueLink"
              to={`/snapscan/ops/merchants/${merchant.id}/payments`}
            >
              {" "}
              {merchant.name}
            </Link>
            {" - "}
            <Link
              className="blueLink"
              to={`/snapscan/fraud/merchant_limit_configs/${merchant.merchant.merchant_limit_configuration.name}/summary`}
            >
              {merchant.merchant.merchant_limit_configuration.name}
            </Link>
          </div>
        );
      });
    };

    const users = (allUsers) => {
      return allUsers.map((user, ui) => {
        return (
          <div key={ui}>
            <Link
              className="blueLink"
              to={`/snapscan/ops/users/${user.external_reference}/payments`}
            >
              {" "}
              {user.email}{" "}
            </Link>
            <a
              style={{ marginLeft: "6px" }}
              target="_blank"
              rel="noopener noreferrer"
              className="blueLink"
              href={user.snapmin_url}
            >
              <i className="fa fa-info-circle" />
            </a>
          </div>
        );
      });
    };

    const showData = () => {
      if (topDevicesList.length > 0) {
        return topDevicesList.map((item, i) => {
          let comments = [];
          item.devices.forEach((device) => {
            if (device.suspicious_token_comment) {
              comments.push(device.suspicious_token_comment);
            }
          });

          return (
            <tr style={{ height: "30px" }} key={i}>
              <td>
                <input
                  type="checkbox"
                  value={i}
                  className="itemSelect"
                  onClick={this.selectRow}
                />
              </td>
              <td
                style={{
                  height: "30px",
                  whiteSpace: "normal",
                  textAlign: "center",
                }}
              >
                {devices(item.devices)}
              </td>
              <td style={{ height: "30px", whiteSpace: "normal" }}>
                {users(item.users)}
              </td>
              <td style={{ textAlign: "right" }}>
                R{(item.total_spend / 100).toFixed(2)}{" "}
              </td>
              <td style={{ textAlign: "right" }}>
                R{(item.lifetime_spend_users / 100).toFixed(2)}{" "}
              </td>
              <td style={{ textAlign: "right" }}>
                {item.ratio_of_total_payments % 1 === 0
                  ? item.ratio_of_total_payments * 100
                  : (item.ratio_of_total_payments * 100).toFixed(2)}
                %
              </td>
              <td style={{ textAlign: "right" }}>
                R{(item.average_tx / 100).toFixed(2)}{" "}
              </td>
              <td>{merchants(item.top_merchants)}</td>
            </tr>
          );
        });
      }
    };

    const modalLog = (Comments) => {
      const convertedData = () => {
        if (Comments) {
          return Comments.map((comment, k) => {
            return <div key={k}>{comment}</div>;
          });
        } else {
          return null;
        }
      };
      return (
        <pre
          style={{
            outline: "1px solid #ccc",
            padding: "5px",
            margin: "5px",
            whiteSpace: "pre-wrap",
          }}
        >
          {convertedData()}
        </pre>
      );
    };

    return (
      <section id="Fraud_LimitHits" className="padded">
        <div
          style={{
            display: "flex",
            justifyContent: "flex-start",
          }}
        >
          <DatePicker
            hintText="Data of"
            onChange={(e, date) => this.changeDate(e, date)}
            defaultDate={this.state.filterDate}
            style={{
              width: "200px",
              marginRight: "10px",
            }}
            textFieldStyle={{
              width: "200px",
            }}
          />
          <BODebounceInput
            minLength={2}
            debounceTimeout={300}
            placeholder="Search Merchant"
            onChange={(newValue) =>
              this.loadData(newValue, this.state.filterDate, 0)
            }
          />
          <SelectField
            hintText="Status"
            value={null}
            onChange={this.handleGroupStatus}
            className={` ${
              this.state.selectedRows.length > 0 ? "shown" : "hidden"
            } `}
          >
            <MenuItem value={"monitored"} primaryText="Monitored" />
            <MenuItem value={"whitelisted"} primaryText="Whitelisted" />
            <MenuItem value={"blacklisted"} primaryText="Blacklisted" />
          </SelectField>
        </div>

        <div
          className={`loader-container ${
            this.state.loading ? "shown" : "hidden"
          }`}
        >
          <i className={`fa fa-spinner fa-spin fa-3x fa-fw`} />
        </div>

        <div
          id="setHeight"
          style={{ height: "calc(100% - 70px)", overflow: "auto" }}
        >
          <table
            style={{
              width: "100%",
            }}
            className={`BOTable`}
            cellPadding={0}
            cellSpacing={0}
          >
            <thead>
              <tr>
                <th style={{ paddingLeft: "2px" }}>
                  <input
                    type="checkbox"
                    className="itemSelectAll"
                    onClick={this.toggleAll}
                  />
                </th>
                <th style={{ textAlign: "center" }}>Devices</th>
                <th>Users</th>
                <th style={{ textAlign: "right" }}>Daily spend</th>
                <th style={{ textAlign: "right" }}>Lifetime spend</th>
                <th style={{ textAlign: "right" }}>Ratio of Total Payments</th>
                <th style={{ textAlign: "right" }}>Average Tx</th>
                <th>Top merchant</th>
              </tr>
            </thead>
            <tbody className={`${this.state.loading ? "hidden" : "shown"} `}>
              {showData()}
            </tbody>
          </table>
        </div>

        <button
          className={
            this.state.offset === 0 || this.state.loading ? "hidden" : ""
          }
          style={{ margin: "5px", padding: "4px" }}
          onClick={this.loadPrev}
        >
          <i className="fa fa-chevron-left" />
        </button>
        <button
          style={{ margin: "5px", padding: "4px" }}
          className={
            topDevicesList.length < 30 || this.state.loading ? "hidden" : ""
          }
          onClick={this.loadNext}
        >
          <i className="fa fa-chevron-right" />
        </button>

        <Dialog
          title="Log"
          modal={false}
          open={this.state.open}
          onRequestClose={this.closeModal}
          actions={[
            <input
              type="button"
              className="button"
              value="Close"
              onClick={this.closeModal}
            />,
          ]}
          autoScrollBodyContent={true}
        >
          {modalLog(this.state.logData)}
        </Dialog>
      </section>
    );
  }
}

const topDevicesWithGraphql = graphql(topDevicesList, {
  options(props: any) {
    return {
      variables: {
        from: null,
        to: null,
        offset: 0,
        limit: 30,
        merchant_search: "",
      },
    };
  },
})(TopDevices);
export default topDevicesWithGraphql;
